<template>
    <v-dialog v-model="shows" width="400" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }">
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="shows = false">mdi-close</v-icon> </v-card-title>
            <v-card-text class="py-5">
                <v-row class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <autocomplete-member v-model="form._member" label="사용자" v-bind="{ ...attrs_input, loading }" />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.amount" label="금액" type="number" suffix="원" v-bind="{ ...attrs_input, loading }" />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.remark" label="비고" v-bind="{ ...attrs_input, loading }" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

import AutocompleteMember from "../dumb/autocompletes/autocomplete-member.vue";

const initUserDeposit = (data = {}) => ({
    ...data,

    _member: data?._member || null,
    amount: data?.amount || 0,
    remark: data?.remark || null,
});

export default {
    components: {
        AutocompleteMember,
    },
    props: {
        _id: { type: String, default: null },
    },
    data: () => ({
        form: initUserDeposit(),

        attrs_input,

        shows: false,
        loading: false,
    }),
    computed: {
        title() {
            let title = "보증금 내역 생성";
            return title;
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                this.form = initUserDeposit();
            } finally {
                this.loading = false;
            }
        },

        validates() {
            try {
                if (!this.form._member) throw new Error("사용자를 선택하세요");
                if (!this.form.amount) throw new Error("금액을 입력하세요");
                if (!this.form.remark) throw new Error("비고를 입력하세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async save() {
            if (!this.validates()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                let deposit = initUserDeposit((await api.console.deposits.post(form))?.deposit);

                alert("생성되었습니다");
                this.$emit("input", deposit);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>
